import { UPDATE_RESOURCE_DEFINITIONS } from 'constants/actions';

import apiClient from 'helpers/api-client';

const RESOURCE_TYPE_STICKER = 'sticker';
const RESOURCE_TYPE_BATEMPLATE = 'before_after_template';

const GET_DRAFT_RESOURCES = false;
const RESOURCE_MAX_VERSION = 2;

const updateResourceDefs = (resourceType, resourceDefs) => ({
  type: UPDATE_RESOURCE_DEFINITIONS,
  resourceType,
  resourceDefs,
});

function loadRemoteResourceDefs(type) {
  return (dispatch) => {
    // Prepare 'get' request data, but without the 'page' field
    const optDrafts = GET_DRAFT_RESOURCES ? { include_drafts: true } : {};
    const requestData = {
      ...optDrafts,
      type,
      version: RESOURCE_MAX_VERSION,
    };

    // Prepare the array aggregating the results from every page
    let aggregateResults = [];

    // Request one page, and then either finish or request the next page
    const requestPage = (page) => {
      apiClient.get('resources', { ...requestData, page }).then((results) => {
        const gotResults = Array.isArray(results) && results.length > 0;
        if (gotResults) {
          aggregateResults = [...aggregateResults, ...results];
          requestPage(page + 1);
        } else {
          dispatch(updateResourceDefs(type, aggregateResults));
        }
      });
    };
    requestPage(1);
  };
}

function loadStickerResourceDefs() {
  return (dispatch) => {
    return dispatch(loadRemoteResourceDefs(RESOURCE_TYPE_STICKER));
  };
}

function loadBAResourceDefs() {
  return (dispatch) => {
    return dispatch(loadRemoteResourceDefs(RESOURCE_TYPE_BATEMPLATE));
  };
}

export { loadStickerResourceDefs, loadBAResourceDefs };
